module.exports = __webpack_public_path__ + "img/icon_description.290f50ed.svg";